export enum NoteComposerSurface {
    ELEVATED = 'elevated',
    BORDERED = 'bordered',
    EMBEDDED = 'embedded',
}
